export default class DashiStore {

    onAttachedToRootStore() {
    }

}
